const UAITS_EVENT_MAP = {
  CLICKED_ON_EXPLORE: 'GTM - Clicked Explore',
  CLICKED_ON_VIEW_SCHEDULE: 'GTM - Clicked View Schedule',
  CHECKOUT_STARTED: 'Checkout - Started',
  CLICKED_ON_SELECT_LOCATION: 'GTM - Selected Preferred Location',
  TTU_CLICKED: 'TTU - Talk to Unacademy Clicked'
};

const UAITS_GOAL_MAP = {
  F1: 'GTM - F1',
  F2: 'GTM - F2'
};

const POSSIBLE_F1 = ['IIT JEE', 'NEET UG'];
const POSSIBLE_F1_UID = ['TMUVD', 'YOTUH']; // This is to send events
const POSSIBLE_F2 = ['Class 11', 'Class 12', 'Dropper'];

export {
  UAITS_EVENT_MAP,
  UAITS_GOAL_MAP,
  POSSIBLE_F1,
  POSSIBLE_F2,
  POSSIBLE_F1_UID
};
